import { Button, Grid, TextField } from "@mui/material";
import { Autocomplete } from '@mui/material';
import { useState } from "react";
import { License, Software } from "../../api/api-generated";
import {
  useFindAllSoftwareQuery,
  useFindLicensesForUserQuery,
  useFindUserForUserQuery,
} from "../../api/api-hooks";
import { downloadLicense } from "../software-sold/licenseUtils";
import { useDownloadSpectrasLicenses } from "../software-sold/useDownloadSpectrasLicenses";

const DownloadLicensesForm = () => {
  const { data: allSoftwareTypes } = useFindAllSoftwareQuery({});
  const { data: profile } = useFindUserForUserQuery({});
  const { data: allLicenses } = useFindLicensesForUserQuery({});
  const spectrasLicenseDownloader = useDownloadSpectrasLicenses();
  const [softwareType, setSoftwareType] = useState<Software | null>(null);
  const [selectedLicenses, setSelectedLicenses] = useState<License[]>([]);
  if (
    allSoftwareTypes === undefined ||
    profile === undefined ||
    allLicenses === undefined ||
    spectrasLicenseDownloader === undefined
  )
    return null;
  const companySoftwareTypeIds = allLicenses.map(
    (license) => license.softwareId
  );
  const companySoftwareTypes = allSoftwareTypes.filter((type) =>
    companySoftwareTypeIds.includes(type.id)
  );
  const handler = (event: any, value: Software | null) => {
    setSoftwareType(value);
    if (value === null) {
      setSelectedLicenses([]);
    } else {
      const licensesForType = allLicenses.filter(
        (license) => license.softwareId === value.id
      );
      setSelectedLicenses(licensesForType);
    }
  };
  const onDownloadClick = () => {
    if (!softwareType) return;
    if (softwareType.type.toLowerCase().includes("spectras")) {
      spectrasLicenseDownloader(selectedLicenses, profile.company.companyName);
    } else {
      downloadLicense(
        softwareType.type,
        profile.company.companyName,
        selectedLicenses
      );
    }
  };
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item>
        <Autocomplete
          onChange={handler}
          value={softwareType}
          options={companySoftwareTypes}
          getOptionLabel={(type) => type.type}
          style={{ width: 200 }}
          renderInput={(params) => (
            <TextField {...params} label="Select Software" variant="outlined" />
          )}
        />
      </Grid>
      <Grid item>
        <Button
          onClick={onDownloadClick}
          variant="contained"
          color="primary"
          disabled={!softwareType}
        >
          Get Licenses
        </Button>
      </Grid>
    </Grid>
  );
};

export default DownloadLicensesForm;
